import _, { cloneWith, result } from "lodash";

import * as addMasterCampaign from '@/api/crm/masterCampaigns/addMasterCampaign';
import * as updateMasterCampaign from '@/api/crm/masterCampaigns/updateMasterCampaign';
import * as deleteMasterCampaign from '@/api/crm/masterCampaigns/deleteMasterCampaign';
import * as getMasterCampaign from '@/api/crm/masterCampaigns/getMasterCampaign';
import * as getMasterCampaigns from '@/api/crm/masterCampaigns/getMasterCampaigns';
import * as activateCampaign from '@/api/crm/masterCampaigns/activateCampaign';
import * as sendCampaign from '@/api/crm/masterCampaigns/sendCampaign';
import * as getMasterCampaignStatistics from '@/api/crm/masterCampaigns/getMasterCampaignStatistics';

export default {
    namespaced: true,
    state: {
        loading: false,
        masterCampaigns: [],
        masterCampaign: null,
        masterCampaignStatistics: null,
    },
    mutations: {
        gotAll(state, masterCampaigns) {
            state.masterCampaigns = masterCampaigns;
        },
        gotSingle(state, masterCampaign) {
            state.masterCampaign = masterCampaign;
        },
        gotStatistics(state, statistics) {
            state.masterCampaignStatistics = statistics;
            console.log(statistics);
        }
    },
    actions: {
        async getAll({ commit }) {
            const result = await getMasterCampaigns.get();
            if (result) commit("gotAll", result);
        },
        async get({ commit }, masterCampaignId) {
            const result = await getMasterCampaign.get(masterCampaignId);
            if (result) commit("gotSingle", result);
        },
        async getStatistics({ commit }, masterCampaignId) {
            var result = await getMasterCampaignStatistics.get(masterCampaignId);
            if (result) commit("gotStatistics", result);
        },

        async create({ dispatch }, dto) {
            const result = await addMasterCampaign.post(dto);
            dispatch("getAll");
            return result;
        },
        async update({ dispatch }, dto) {
            await updateMasterCampaign.put(dto);
            dispatch("getAll")
        },
        async delete({ dispatch }, id) {
            await deleteMasterCampaign.del(id);
            dispatch("getAll")
        },

        async activateCampaign({ dispatch }, id) {
            await activateCampaign.post(id);
            dispatch("get", id)
        },
        async sendCampaign({ dispatch }, id) {
            await sendCampaign.post(id);
            dispatch("get", id)
        },

    },
    getters: {
        all: state => state.masterCampaigns,
        masterCampaign: state => state.masterCampaign,
        masterCampaignStatistics: state => state.masterCampaignStatistics,
        // venueCampaigns: state => state.venueCampaigns,
        // draftCampaigns: state => state.masterCampaigns.filter(e => e.masterStatus === "Draft"),
        // activeCampaigns: state => state.masterCampaigns.filter(e => e.masterStatus === "Active"),

        // draftCampaigns: state => (id) => state.crmEvents.find(e => e.id === id),

        // pendingCampaigns: state => state.pendingCampaigns,
        // marcomEvents: state => state.crmEvents //state.crmEvents.filter(e => e.identifier.startsWith("booking"))
    }
};
